module.exports = __webpack_public_path__ + "static/media/iconpdf.83bf49bb.svg";